@if (page != null) {
  <portal-pagination
    [initializeFromStorage]="datatablePage.tableWasDestroyed === false"
    [page]="page"
    [simple]="true"
    (onPageChanged)="onPageChanged($event)"
  ></portal-pagination>
}
